// Deliberately loose: catches typos like a missing "@" or domain without
// rejecting unusual-but-valid addresses. The server is the real authority.
export const isValidEmail = value => /^\S+@\S+\.\S+$/.test(value.trim());
